import { render, staticRenderFns } from "./dts.vue?vue&type=template&id=572d8512&scoped=true"
import script from "./dts.vue?vue&type=script&lang=js"
export * from "./dts.vue?vue&type=script&lang=js"
import style0 from "./dts.vue?vue&type=style&index=0&id=572d8512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d8512",
  null
  
)

export default component.exports